import { map as _map } from 'lodash-es';
import { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { makeStyles } from 'tss-react/mui';
import FilterHdrIcon from '@mui/icons-material/FilterHdr';
import SelectField from '../forms/select-field';
import { eventTerrains } from '../../utils/events';
import type { EventFormValues } from './form';

const useStyles = makeStyles()((theme) => ({
  label: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: theme.spacing(0.5),
    fontSize: 16,
  },
}));

const EventFormTerrains = (props) => {
  const { classes } = useStyles();
  const { values: { eventType } } = useFormikContext<EventFormValues>();

  const options = useMemo(() => _map(eventTerrains, ({ name, description }, value) => ({
    label: `${name} (${description})`,
    value,
  })), []);

  if (eventType !== 'RIDE') {
    return null;
  }

  return (
    <SelectField
      name="terrain"
      label={(
        <span className={classes.label}>
          <FilterHdrIcon className={classes.icon} />
          Terrain (optional)
        </span>
      )}
      options={options}
      placeholder="Choose One"
      {...props}
    />
  );
};

export default EventFormTerrains;
